<template>
  <!-- 七天试用期内弹框 -->
  <!-- 绑卡引导弹窗：用户已配置完成 campaign，等待支付发布。仅允许通过下方操作按钮跳转关闭，不可通过遮罩 / 关闭按钮 / Esc 关闭 -->
  <a-modal v-if="visible" v-model="visible" title="" :centered="true" :footer="null" :closable="false"
    :maskClosable="false" :keyboard="false" :width="720" dialogClass="global-bind-card-modal-class">
    <div class="bind-modal-con">
      <h1 class="bind-title">
        <span class="title-emoji">&#128640;</span>
        <span>
          {{ $t("bindModalTitlePrefix") }}
          <strong>{{ target_count }} {{ camp == 1 ? $t("bindModalMatchedCustomer") : $t("bindModalMatchedCandidate")
          }}</strong>
          {{ $t("bindModalTitleSuffix") }}
        </span>
      </h1>

      <p class="bind-description">
        {{ $t("bindModalDesc") }} &mdash;
        <strong>{{ $t("bindModalDescBold") }}</strong>
      </p>

      <div class="bind-campaign-card">
        <div class="card-head">
          <span class="pending-badge">{{ $t("bindModalPendingBadge") }}</span>
          <span class="campaign-name">{{ campaignName }}</span>
        </div>
        <p class="card-stats">
          <strong>{{ target_count }}</strong>
          {{ camp == 1 ? $t("bindModalStatsCustomerMatched") : $t("bindModalStatsCandidateMatched") }} &middot;
          {{ $t("bindModalStatsReplies") }} &middot;
          {{ $t("bindModalStatsCreated", { date: createdDate }) }}
        </p>
      </div>

      <div class="bind-trial-notice">
        <span class="trial-emoji">&#127873;</span>
        <p>
          {{ $t("bindModalNoticePrefix") }}
          <strong>{{ $t("bindModalNoticeBold") }}</strong>
          {{ $t("bindModalNoticeSuffix") }}
        </p>
      </div>

      <div class="bind-action-row">
        <a-button type="primary" class="btn-continue" @click="goPayStep1">
          {{ $t("bindModalContinueBtn") }}
          <span class="arrow">&rarr;</span>
        </a-button>
        <a-button class="btn-edit" @click="goEdit">
          {{ $t("bindModalEditBtn") }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { mapState } from "vuex";
// import { EventOnEventStart, EventEnd } from "@/layouts/dialog-config/index";
const $EventName = "global_active_freeModal_20241101";
import dayjs from "dayjs";
export default {
  data() {
    return {
      visible: false,
      havedays: 0,
      campName: "",
      creatTime: "",
      campaignName: "",
      matchCount: 0,
      createdDate: "",
      matchedNoun: "",
      target_count: "0"
    };
  },
  props: ["camp"],
  i18n: require("./i18n"),
  computed: {
    ...mapState("setting", ["lang"]),
  },
  activated() {
    if (
      (this.user.sales_pay_toast_id && this.camp == 1) ||
      (this.user.hr_pay_toast_id && this.camp == 2)
    ) {
      this.visible = true;
      if (this.user.sales_pay_toast_id) {
        this.campaignName = this.user.sales_campaign_name;
        this.target_count = this.user.sales_payment_pending_campaign ? this.user.sales_payment_pending_campaign.target_count : 0;
        this.createdDate = this.user.sales_payment_pending_campaign ? dayjs(this.user.sales_payment_pending_campaign.created_at).format(
          "MM-DD"
        ) : 0;
      } else if (this.user.hr_pay_toast_id) {
        this.campaignName = this.user.hr_campaign_name;
        this.target_count = this.user.recruiter_payment_pending_campaign ? this.user.recruiter_payment_pending_campaign.target_count : 0;
        this.createdDate = this.user.recruiter_payment_pending_campaign ? dayjs(this.user.recruiter_payment_pending_campaign.created_at).format("MM-DD") : 0;
      }
    }
  },
  async created() {
    // EventOnEventStart($EventName, this.eventStartModal);
  },
  methods: {
    // 关闭弹框回调
    closeModal() {
      this.visible = false;
      //   EventEnd($EventName);
    },
    // 判断是否显示弹框，试用期内展示弹框
    isShowModal() {
      if (this.user && this.user.paid == 1) {
        return false;
      }
      if (this.user && this.user.free_info) {
        // 一天校验一次
        let showTime = localStorage.getItem("showFreeModal");
        let newDate =
          new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate();
        // if (showTime && Date.now() - new Date(showTime).getTime() < 24 * 60 * 60 * 1000) {
        if (showTime && showTime == newDate) {
          return false; // 一天内不展示弹框
        }
        localStorage.setItem("showFreeModal", newDate); // 存储今天时间
        let { end_date } = this.user.free_info;
        // let start = new Date(start_date).getTime();
        let end = new Date(end_date).getTime();
        if (Date.now() > end) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    getDays() {
      if (this.visible) {
        let { end_date } = this.user.free_info;
        let end = new Date(end_date).getTime() - 3000;
        let diffTime = Math.ceil((end - Date.now()) / (24 * 60 * 60 * 1000));
        return diffTime > 0 ? diffTime : 0;
      } else {
        return 0;
      }
    },
    goEdit() {
      this.closeModal();
      this.writeLog("plan", "alert_win", "edit_campaign");
      if (this.camp == 1) {
        this.$router.push({
          path: "/sales/salesReps/createCampaign",
          query: { campaign_id: this.user.sales_pay_toast_id, edit: 2 },
        });
      } else if (this.camp == 2) {
        this.$router.push({
          path: "/hr/recruiter/createCampaign",
          query: { campaign_id: this.user.hr_pay_toast_id, edit: 2 },
        });
      }
    },
    // 进入支付第一步
    goPayStep1() {
      this.writeLog("plan", "alert_win", "pay_now");
      this.closeModal();
      this.$router.push({
        path: this.camp == 1 ? "/sales/salesReps/plan" : "/hr/recruiter/plan",
        query: {
          // 有账户时可以在付完费直接绑定
          upgrade_free: 1,
          campaign_id: parseInt(this.camp == 1 ? this.user.sales_pay_toast_id : this.user.hr_pay_toast_id),
          // 默认选中1
          campaign_type: this.camp,
          isfromCamp: 1,
        },
      });
    },
    eventStartModal(data) {
      if (data && data.name === $EventName) {
        this.visible = this.isShowModal();
        this.havedays = this.getDays();
        if (!this.visible) {
          //   EventEnd($EventName);
        }
      }
    },
  },
  // watch: {
  //   "$route.path": {
  //     immediate: true,
  //     handler() {
  //       if (
  //         this.$route.query.isNew == 1 ||
  //         // localStorage.getItem("showGuide") == "1"
  //         (this.userGuide &&
  //         (this.userGuide.sales_progress == 0 && this.$route.path == '/sales/salesReps/campaign') ||
  //         (this.userGuide.hr_progress == 0 && this.$route.path == '/hr/recruiter/campaign') ||
  //         (this.userGuide.sales_progress < 4 && this.$route.path == '/sales/salesReps/createCampaign' && this.$route.query.linkedin_id == 'new') ||
  //         (this.userGuide.hr_progress < 4 && this.$route.path == '/hr/recruiter/createCampaign' && this.$route.query.linkedin_id == 'new'))
  //       ) {
  //         return;
  //       }
  //       this.visible = this.isShowModal();
  //       this.havedays = this.getDays();
  //     },
  //   },
  // },
};
</script>
<style lang="less" scoped>
.bind-modal-con {
  padding: 30px 32px 30px;
  color: #101817;
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.bind-title {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0 0 14px;
  font-size: 22px;
  line-height: 1.35;
  font-weight: 800;
  color: #1d2c29;

  .title-emoji {
    flex-shrink: 0;
    font-size: 22px;
    line-height: 1.35;
  }

  strong {
    color: #0c8a72;
    font-weight: 900;
  }
}

.bind-sales-version {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin: 0 0 18px;
  padding: 10px 14px;
  border-radius: 8px;
  background: #f4f7f6;
  color: #5d6b68;
  font-size: 13px;
  line-height: 1.45;
  font-weight: 700;

  .swap-icon,
  .inline-emoji {
    font-size: 14px;
    line-height: 1;
  }

  strong {
    color: #0c8a72;
    font-weight: 800;
  }
}

.bind-description {
  margin: 0 0 18px;
  color: #4a5552;
  font-size: 14px;
  line-height: 1.55;

  strong {
    color: #15211f;
    font-weight: 800;
  }
}

.bind-campaign-card {
  margin: 0 0 14px;
  padding: 16px 18px;
  border: 1px solid #dfe7e3;
  border-radius: 12px;
  background: #fff;
}

.card-head {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 8px;
}

.pending-badge {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 10px;
  border-radius: 6px;
  background: #fff3df;
  color: #b06a1d;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}

.campaign-name {
  color: #15211f;
  font-size: 15px;
  font-weight: 800;
}

.card-stats {
  margin: 0;
  color: #5d6b68;
  font-size: 13px;
  line-height: 1.5;

  strong {
    color: #0c8a72;
    font-weight: 800;
  }
}

.bind-trial-notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0 0 24px;
  padding: 14px 18px;
  border-radius: 12px;
  background: #ecf6f3;
  color: #21564c;
  font-size: 13px;
  line-height: 1.5;

  .trial-emoji {
    flex-shrink: 0;
    font-size: 16px;
    line-height: 1.5;
  }

  p {
    margin: 0;
  }

  strong {
    color: #0c8a72;
    font-weight: 800;
  }
}

.bind-action-row {
  display: flex;
  align-items: stretch;
  gap: 12px;
}

.btn-continue {
  flex: 1.6;
  min-width: 260px;
  height: 56px;
  padding: 0 22px;
  border: 0;
  border-radius: 10px;
  background: #f26122;
  color: #fff !important;
  font-size: 16px;
  font-weight: 800;
  box-shadow: 0 8px 20px rgba(242, 97, 34, 0.22);
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

  &:hover,
  &:focus {
    background: #e05517;
    color: #fff !important;
    transform: translateY(-1px);
    box-shadow: 0 12px 26px rgba(242, 97, 34, 0.28);
  }

  &:active {
    transform: scale(0.99);
  }

  .arrow {
    display: inline-block;
    margin-left: 6px;
  }
}

.btn-edit {
  flex: 1;
  min-width: 160px;
  height: 56px;
  padding: 0 22px;
  border: 1px solid #dfe7e3;
  border-radius: 10px;
  background: #fff;
  color: #1d2c29 !important;
  font-size: 16px;
  font-weight: 800;
  transition: border-color 0.2s ease, color 0.2s ease, background 0.2s ease;

  &:hover,
  &:focus {
    border-color: #0c8a72;
    background: #f4f7f6;
    color: #0c8a72 !important;
  }
}

@media (max-width: 720px) {
  .bind-modal-con {
    padding: 22px 16px;
  }

  .bind-title {
    font-size: 18px;
  }

  .bind-action-row {
    flex-direction: column;
  }

  .btn-continue,
  .btn-edit {
    width: 100%;
    min-width: 0;
  }
}
</style>
<style lang="less">
.global-bind-card-modal-class {
  width: 720px !important;
  max-width: calc(100vw - 32px);

  .ant-modal-body {
    padding: 0;
  }

  // 强制隐藏 antd 自带的右上角关闭按钮，确保不可关闭
  .ant-modal-close {
    display: none !important;
  }
}
</style>
